<template>
  <div class="row full-height bg d-flex flex-row justify-content-center">
    <div class="col-sm-12 col-md-6 col-lg-4 d-flex">

      <card class="center content align-self-center">

        <form @submit.prevent="login()" method="POST" role="form">
          <div class="d-flex justify-content-center mb-3">
            <img src="~assets/img/logo.png" class="img-fluid">
          </div>

          <fg-input v-model="data.name" placeholder="Usuario" type="text"/>

          <fg-input v-model="data.password" placeholder="Contraseña" type="password"/>

          <p>
            <button type="submit" class="btn btn-info btn-block">Entrar</button>
          </p>
        </form>

      </card>

    </div>
  </div>
</template>

<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import swal from 'sweetalert'

  export default {
    name: 'Login',
    data () {
      return {
        data: {
          name: '',
          password: ''
        }
      }
    },
    components: {
      Card
    },
    methods: {
      login () {
        console.log('Login')
        this.$http.post('login', this.data).then(res => {
          let data = res.data
          console.info('Data', data)
          if (data.status === 0) {
            console.log('Status', data.status)
            swal(data.message, 'Saludo', 'success', {
              buttons: false
            })
            setTimeout(() => {
              localStorage.setItem('api_token', data.user.api_token)
              localStorage.setItem('type', data.user.type || 'USR')
              this.$router.go('/admin')
            }, 2000)
          }
        })
          .catch(err => {
            console.error(err.response)
            if (err && err.response && err.response.data) {
              const keys = Object.keys(err.response.data)
              if (keys.length) {
                const error = err.response.data[keys[0]][0]
                swal('Alerta', error, 'warning')
              }
            }
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .full-height {
    height: 100vh;
  }

  .relative {
    position: relative;
  }

  .center {
    margin: 0 auto;
  }

  .content {
    img {
      margin: auto;
      max-height: 150px;
    }
  }

  .bg {
    background: #ad47d9 url('~/static/img/bg-login.png');
    background-size: cover;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Login.vue